import axios from 'axios';
import mutationHelpers from '../../utils/mutation-helpers';
import { getCookie, currency } from '../../utils/helpers';
const path = process.env.VUE_APP_ROOT_API;

const state = {
  status: null,
  stats: [],
  errors: []
};

// getters
const getters = {};

// actions
const actions = {
  FETCH: async ({ commit }, { id }) => {
    const token = getCookie('token');
    
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    const {
      data: { stats }
    } = await axios.get(`${path}/api/user/${id}/stats-herd`);
    commit('SET_STATS', stats);
  },
  RESET: ({ commit }) => {
    commit('RESET_STATS');
  }
};

// mutations
const mutations = {
  UPDATE_STATUS: mutationHelpers.UPDATE_STATUS,
  RESET_ERRORS: mutationHelpers.RESET_ERRORS,
  SET_ERROR: mutationHelpers.SET_ERROR,

  SET_STATS(state, stats) {
    state.stats = stats.map(o => {
      if (o.itemClass === 'stat-herd-value') {
        o.value = currency(o.value);
      }

      return o;
    });
  },
  RESET_STATS(state) {
    state.stats = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
